import {
    Component,
    OnInit,
    Input,
    ChangeDetectorRef,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import {
    UntypedFormBuilder,
    Validators,
    UntypedFormArray,
    UntypedFormGroup,
    FormControl,
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import { ProductPageService } from '@services/productPage.service';
import { OptionsEventService } from '@services/optionsEvent.service';
import * as _ from 'lodash';
/* import { ObjectId } from 'bson'; */
import { ActivatedRoute } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { CurrencyConvertPipe } from '../../../shared/pipes';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ClickDirective } from '../../../shared/directives/click.directive';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgFor, NgClass, NgIf, KeyValuePipe } from '@angular/common';
import { ProductOptionType } from '@app/_models';

@Component({
    selector: 'app-product-options',
    templateUrl: './product-options.component.html',
    styleUrls: ['./product-options.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        ExtendedModule,
        NgIf,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        ClickDirective,
        BsDatepickerModule,
        KeyValuePipe,
        TranslateModule,
        CurrencyConvertPipe
    ]
})
export class ProductOptionsComponent implements OnInit, OnChanges {
    constructor(
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        public optionsEventService: OptionsEventService,
        private fb: UntypedFormBuilder,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) {}

    @Input() baseForm: UntypedFormGroup;

    @Input() optionsObject;

    @Input() product;
    @Input() class;

    @Output() optionChanged: EventEmitter<any> = new EventEmitter();

    file;
    files = [];
    ProductOptionType = ProductOptionType;

    ngOnInit(): void {
        this.buildOptions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const properties = Object.keys(changes);
        if (
            properties.includes('optionsObject') ||
            properties.includes('product')
        ) {
            this.buildOptions();
        }
    }

    buildOptions() {
        if (!this.baseForm.get('options')) {
            this.baseForm.addControl('options', this.fb.array([]));
        } else {
            this.options.clear();
        }
        if (!this.baseForm.get('optionFiles'))
            this.baseForm.addControl('optionFiles', this.fb.array([]));
        else {
            this.optionFiles.clear();
        }
        _.forEach(this.optionsObject, (option, key) => {
            // let defaultValue = (option?.required) ? _.findKey(option?.values) : null;
            let optionForm;
            if (option.type == ProductOptionType.Date) {
                optionForm = this.fb.group({
                    optionId: key,
                    date: null,
                    time: null
                });
                if (option.required) {
                    optionForm.get('date').addValidators(Validators.required);
                    optionForm.get('time').addValidators(Validators.required);
                }
            } else {
                optionForm = this.fb.group({
                    optionId: key,
                    valueId: null,
                    value: null
                });
                if (option.required) {
                    optionForm.get('value').addValidators(Validators.required);
                    // optionForm.get('valueId').addValidators(Validators.required);
                }
            }
            this.options.push(optionForm);
        });
    }

    get optionsFormArray(): UntypedFormArray {
        return this.baseForm.get('options') as UntypedFormArray;
    }

    getMinmumDays(minDays) {
        if (!minDays) {
            return;
        }
        let minDate = new Date();
        minDate.setDate(minDate.getDate() + parseInt(minDays));
        return minDate;
    }

    fileBrowseHandler(controller, files, option) {
        for (const item of files) {
            let _id = Math.ceil(Math.random() * 1000000);
            controller.get('value').setValue(item.name);
            controller.get('valueId').setValue(_id);

            if (item.size > 1024 * 2 * 1000) {
                console.log('Image size is bigger than 2MB', 'X', {
                    duration: 3000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['red-snackbar']
                });
                continue;
            }

            const reader = new FileReader();
            reader.onload = () => {
                item.url = reader.result as string;
            };
            reader.readAsDataURL(item);
            let file = item;
            file._id = _id;
            file.index = (this.optionFiles.value?.length || 0) + 1;

            option.file = file;
            this.optionFiles.push(
                this.fb.group({
                    [_id]: file
                })
            );
        }
    }

    remove(controller, option) {
        controller.get('value').setValue(null);
        controller.get('valueId').setValue(null);
        this.optionFiles.removeAt(option.file.index);
        delete option.file;
    }

    get options(): UntypedFormArray {
        return this.baseForm.get('options') as UntypedFormArray;
    }

    get optionFiles(): UntypedFormArray {
        return this.baseForm.get('optionFiles') as UntypedFormArray;
    }

    checkCobination(option, key) {
        if (!option.combination || !option.combOptionId) return;
        this.optionsObject[option.combOptionId].values = option[key];
        let options = this.options.value;
        let optionIndex = _.findIndex(options, [
            'optionId',
            option.combOptionId
        ]);
        if (optionIndex > -1) {
            this.options
                .at(optionIndex)
                .get('valueId')
                .patchValue(null);
            this.options
                .at(optionIndex)
                .get('valueId')
                .updateValueAndValidity();
        }
    }

    checkboxChange(controller: UntypedFormGroup, valueId) {
        if (controller.get('value')?.value && valueId) {
            controller.get('valueId').setValue(valueId);
        } else {
            controller.get('valueId').setValue(null);
        }
    }
}
